// Home.tsx
import React from "react";
import HeroVideo from "../../components/static-herosection/StaticHeroSection";
import BookShipments from "../../components/bookshipments/BookShipments";
import FixedBackgroundScrolling from "../../components/fixed-background-scrolling/FixedBackgroundScrolling";
// import AwardsSlider from "../../components/award-slider/AwardSlider";
import StatBar from "../../components/footer/StatBar";
// import { awardsSliderData } from "../../data/AwardSliderData";
import About from "../../components/about/about";
import OurPromises from "../about/our-promises/OurPromises";

const Home: React.FC = () => {
  return (
    <div className="Home">
      <HeroVideo />
      <BookShipments />
      <FixedBackgroundScrolling />
      <About/>
      {/* <AwardsSlider Awards={awardsSliderData} /> */}
      <StatBar />
    </div>
  );
};

export default Home;
